<div class="input-head" *ngIf="label" [ngStyle]="{'minWidth':hasInlineLabel ? labelWidth: 'auto','maxWidth': !hasInlineLabel ? labelWidth: 'auto'}">
  <label tooltip [tooltipPosition]="'bottom'" [tooltipContent]="!disabled?description:''" *ngIf="!hasToggleLabel">{{label}}</label>
  <app-label-toggle tooltip [tooltipPosition]="'bottom'" [tooltipContent]="!disabled?description:''" [toggleStyle]="importantStyle" [disabled]="disabled && !forceLabel" *ngIf="hasToggleLabel" [active]="important" (activeChange)="onImportantChange($event)">{{label}}</app-label-toggle>
  <i (click)="onClickReset()" class="input-reset aki aki-pic_cross"></i>
</div>
<div class="input-content" [ngStyle]="{'maxWidth':inputWidth ? inputWidth: 'auto'}">
  <div class="input-element">
    <input name="{{label|replace:' ':''}}" [readonly]="readonly" [type]="inputType" placeholder="{{placeholder}}" [disabled]="disabled || disabledInput" (keydown)="onKeyDown($event)" class="text-align-{{textAlign}}" type="text" #input [(ngModel)]='val' name="{{ label + '_' + id }}" [pattern]="pattern" autocomplete="off"
           autocorrect="off"
           autocapitalize="none"
           spellcheck="false" />
    <ng-content></ng-content>
  </div>
  <div class="unit" *ngIf="unit">{{unit}}</div>
</div>
